import { Avatar, Box, Text } from '@factorialco/deprecated-design-system'
import { AccessAndEmployeeInfoFragment } from 'generated/resources/graphql'

import UserAvatar from 'modules/core/components/UserAvatar'
import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

import { InlineEmployee } from 'modules/employees/components/InlineEmployee'

export const EnrolledEmployees = ({
  access,
  onlyAvatar = false,
}: {
  access: AccessAndEmployeeInfoFragment | null | undefined
  onlyAvatar?: boolean
}) => {
  if (access) {
    if (access.employee) {
      const employee = {
        id: access.employee.id,
        preferredName: access.employee.preferredName,
        access: {
          fullName: access.fullName,
          avatar: access.avatar,
        },
      }
      if (onlyAvatar) {
        return <Avatar size="s32" url={buildUrl(access.avatar)} label={access.fullName} />
      } else {
        return <InlineEmployee employee={employee} variant="medium" linkProfile />
      }
    } else {
      return (
        <Box flexDirection="row" gap="s12" alignItems="flexStart">
          <UserAvatar user={access} size="s24" />
          <Text.Normal size="300" color="grey1000" capitalize>
            {access.fullName}
          </Text.Normal>
        </Box>
      )
    }
  } else {
    return (
      <Text.Normal>
        {i18n.t('trainings.trainings_revamp.training_detail.employees_table.unknown')}
      </Text.Normal>
    )
  }
}
